import { CommunityTypeFragment, useCommunityTypesLazyQuery } from 'shared/graphql';

import {
  FormSelectDataSource,
  FormSelectDataSourceOption,
  FormSelectDataSourceOptionText,
  FormSelectDataSourceDefinitionProps,
  FORM_SELECT_DATASOURCE_SUGGESTIONS_COUNT,
} from '../FormSelectDataSource';

type Props = FormSelectDataSourceDefinitionProps<CommunityTypeFragment>;

export function FormSelectCommunityTypes(props: Props) {
  const [fetchConfigurations] = useCommunityTypesLazyQuery();

  const fetchOptions = async (search: string) => {
    const isSuggestions = search.length === 0;

    const response = await fetchConfigurations({
      variables: {
        first: isSuggestions ? FORM_SELECT_DATASOURCE_SUGGESTIONS_COUNT : undefined,
        // sort: [{ name: SortDirection.ASC }],
        filter: { name: { contains: search } },
      },
    });

    return response.data?.communityTypes.items ?? [];
  };

  const extractIdentifier = (option: CommunityTypeFragment) => {
    return option.id as string;
  };

  const extractLabel = (option?: CommunityTypeFragment) => {
    return option?.name ?? '(Unknown)';
  };

  return (
    <FormSelectDataSource<CommunityTypeFragment>
      {...props}
      extractIdentifier={extractIdentifier}
      extractLabel={extractLabel}
      fetchOptions={fetchOptions}
    >
      {(params, option) => (
        <FormSelectDataSourceOption {...params} key={option?.id}>
          <FormSelectDataSourceOptionText>{option.name}</FormSelectDataSourceOptionText>
        </FormSelectDataSourceOption>
      )}
    </FormSelectDataSource>
  );
}
